import axios from 'axios'
import store from './store'
import { usesAbiturientBearerAuth, usesCollegeBearerAuth } from './utils/auth'

function applyLanguageHeader(lang) {
	axios.defaults.headers.common['X-Language'] = lang || 'ru';
}

applyLanguageHeader(store.getters.getLanguage);
store.dispatch('changeBaseUrl');

axios.interceptors.request.use((config) => {
	config.headers['X-Language'] = store.getters.getLanguage;
	return config;
});

if (store.getters.getAccessToken) {
	const authMethod = store.getters.getAuthMethod;
	const role = store.getters.getCurrentRole;
	if (usesAbiturientBearerAuth(role, authMethod) || usesCollegeBearerAuth(role, authMethod)) {
		axios.defaults.headers.common['Authorization'] = 'Bearer ' + store.getters.getAccessToken;
	} else {
		axios.defaults.headers.common['X-Auth'] = store.getters.getAccessToken;
	}
}

axios.interceptors.response.use((response) => {
	return response;
}, function (error) {
	const response = error.response;
	if (!response) {
		return Promise.reject(error);
	}
	if (!error.config || !error.config.silent) {
		const message = (response.data && response.data.message) || error.message;
		store.dispatch('alertAdd', { text: message, type: 'error' });
	}
	if (response.status === 401) {
		store.dispatch('logout');
	}
	return Promise.reject(error);
});
